import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_attendanceProjectList = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/projects/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_attendanceSubmit = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_attendanceDetails = async (projectId, attendanceDate) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/${projectId}/${attendanceDate}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_userMonthlyAttendance = async (projectId, month, year, userId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/user-monthly/${projectId}/${month}/${year}/${userId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_myMonthlyAttendance = async (month, year) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/my/${month}/${year}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_cofirmMonthlyAttendance = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/confirm`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_projectMonthlyAttendance = async (projectId, month, year) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/monthly/${projectId}/${month}/${year}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_projectMonthlyAttendanceStatus = async (projectId, month, year) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/status/${projectId}/${month}/${year}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}






export const v3_projectMonthlyAttendanceVerify = async (projectId, month, year) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/verify/${projectId}/${month}/${year}`;
    return customAxios.patch(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




